<script lang="ts" setup>
const { t } = useI18n();
const shapesStore = useShapesStore();

const canUndo = computed(() => shapesStore.historyState.canUndo);
const canRedo = computed(() => shapesStore.historyState.canRedo);
const onUndoClick = () => shapesStore.historyState.undo();
const onRedoClick = () => shapesStore.historyState.redo();
</script>

<template>
  <TButton
    :tooltip="t('labels.undo')"
    icon="undo"
    class="hover:bg-blue-500 disabled:hover:bg-transparent"
    :disabled="!canUndo"
    @click="onUndoClick"
  />
  <TButton
    :tooltip="t('labels.redo')"
    icon="redo"
    class="hover:bg-blue-500 disabled:hover:bg-transparent"
    :disabled="!canRedo"
    @click="onRedoClick"
  />
</template>
